export default {
    LOGIN_LOADING: "LOGIN_LOADING",
};